
export enum PickupRequestReasonCategoryCd {
	CANCEL_REASON = 'CancelReason',
	RESCHEDULE_REASON = 'RescheduleReason'}
